import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3272c89c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper-recipe-form" }
const _hoisted_2 = { class: "recipe-form" }
const _hoisted_3 = { class: "container-row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Title", -1))
const _hoisted_5 = { class: "container-row" }
const _hoisted_6 = { class: "container-row" }
const _hoisted_7 = { class: "container-row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Images", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Tags", -1))
const _hoisted_10 = { class: "container-bottom" }
const _hoisted_11 = { class: "container-bottom-tags" }
const _hoisted_12 = { class: "container-submit" }
const _hoisted_13 = { class: "container-time" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "container-time-label" }, "Prep time", -1))
const _hoisted_15 = { class: "container-time" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "container-time-label" }, "Cook time", -1))
const _hoisted_17 = { class: "container-time" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "container-time-label" }, "Servings", -1))
const _hoisted_19 = ["value"]
const _hoisted_20 = {
  key: 0,
  class: "modal-info"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Ingredients", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = {
  key: 1,
  class: "modal-info"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Method", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RecipeTitle = _resolveComponent("RecipeTitle")!
  const _component_InformationCircleIcon = _resolveComponent("InformationCircleIcon")!
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_RecipeImages = _resolveComponent("RecipeImages")!
  const _component_RecipeTags = _resolveComponent("RecipeTags")!
  const _component_RecipeEstimatedTime = _resolveComponent("RecipeEstimatedTime")!
  const _component_RecipeServings = _resolveComponent("RecipeServings")!
  const _component_RecipePrivate = _resolveComponent("RecipePrivate")!
  const _component_RecipeStatus = _resolveComponent("RecipeStatus")!
  const _component_ModalView = _resolveComponent("ModalView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.startFlow && _ctx.startFlow(...args)))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_RecipeTitle, {
            "recipe-title": _ctx.recipe.title,
            onUpdateRecipeData: _ctx.updateRecipeData
          }, null, 8, ["recipe-title", "onUpdateRecipeData"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h2", null, [
            _createTextVNode(" Ingredients "),
            _createVNode(_component_InformationCircleIcon, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isModalIngredients = true))
            })
          ]),
          _createVNode(_component_QuillEditor, {
            placeholder: "Ingredients",
            onTextChange: _ctx.updateRecipeIngredients,
            required: ""
          }, null, 8, ["onTextChange"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h2", null, [
            _createTextVNode(" Method "),
            _createVNode(_component_InformationCircleIcon, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isModalMethod = true))
            })
          ]),
          _createVNode(_component_QuillEditor, {
            placeholder: "Method",
            onTextChange: _ctx.updateRecipeMethod,
            required: ""
          }, null, 8, ["onTextChange"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_RecipeImages, {
            "existing-images": _ctx.recipe.images,
            onAddRecipeImage: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('addRecipeImage', $event))),
            onRemoveRecipeImage: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('removeRecipeImage', $event)))
          }, null, 8, ["existing-images"])
        ]),
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_RecipeTags, {
              tags: _ctx.userTags,
              "author-id": _ctx.contextUser._id,
              "selected-tags": _ctx.selectedTags,
              onUpdateRecipeData: _ctx.updateRecipeData
            }, null, 8, ["tags", "author-id", "selected-tags", "onUpdateRecipeData"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_RecipeEstimatedTime, {
                time: _ctx.recipe.prepTime || 0,
                onUpdateRecipeData: _ctx.updateRecipeData,
                type: "PREP"
              }, null, 8, ["time", "onUpdateRecipeData"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_RecipeEstimatedTime, {
                time: _ctx.recipe.cookTime || 0,
                onUpdateRecipeData: _ctx.updateRecipeData,
                type: "COOK"
              }, null, 8, ["time", "onUpdateRecipeData"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(_component_RecipeServings, {
                "portion-size": _ctx.recipe.servings || 0,
                onUpdateRecipeData: _ctx.updateRecipeData
              }, null, 8, ["portion-size", "onUpdateRecipeData"])
            ]),
            _createVNode(_component_RecipePrivate, {
              "is-private": _ctx.recipe.isPrivate,
              onUpdateRecipeData: _ctx.updateRecipeData
            }, null, 8, ["is-private", "onUpdateRecipeData"]),
            (_ctx.recipe.publishDate.length === 0)
              ? (_openBlock(), _createBlock(_component_RecipeStatus, {
                  key: 0,
                  status: _ctx.recipe.status,
                  label: 
                _ctx.recipe._id && _ctx.recipe.status === 'DRAFT' ? 'Published' : 'Draft'
              ,
                  onUpdateRecipeData: _ctx.updateRecipeData
                }, null, 8, ["status", "label", "onUpdateRecipeData"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("input", {
          class: "button-save-green",
          type: "submit",
          value: _ctx.recipe.status === 'DRAFT' ? 'Save' : 'Publish'
        }, null, 8, _hoisted_19)
      ], 32)
    ]),
    _createVNode(_component_ModalView, {
      "is-open": _ctx.isModalIngredients || _ctx.isModalMethod,
      onOnCloseClicked: _cache[5] || (_cache[5] = ($event: any) => {
        _ctx.isModalIngredients = false;
        _ctx.isModalMethod = false;
      })
    }, {
      default: _withCtx(() => [
        (_ctx.isModalIngredients)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _hoisted_21,
              _createTextVNode(" Be sure to make use of the conversion table in the side-bar."),
              _hoisted_22,
              _createTextVNode(" Formatting your ingredients into bullet-points makes is more readable and when clicking/ tapping on them, it will cross it out! Giving you a clear view on which ingredients you have yet to use. ")
            ]))
          : _createCommentVNode("", true),
        (_ctx.isModalMethod)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _hoisted_24,
              _createTextVNode(" Try to keep your steps short, clear and simple."),
              _hoisted_25,
              _createTextVNode(" Make sure to number your steps with the tools above the input field! When clicking/ tapping on them, it will cross it out! Giving you a clear view on which steps you have already done. ")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-open"])
  ]))
}